import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import type { ProcessHistoryEntry } from '../../api/types/postSale';

/**
 * Renders a reservation's operation audit trail. The legacy app appended a
 * `ProcessHistory` / `ChangeHistory` row for every void/refund/open/change/note; the
 * post-sale endpoints return the same list at `shoppingCart.processHistories`. Any
 * monetary detail (refund fare breakdown, penalty, service fee) is embedded in
 * `explanation` — the backend keeps no separate amount column.
 */
export function ProcessHistoryPanel({ entries }: { entries?: ProcessHistoryEntry[] | null }) {
  if (!entries || entries.length === 0) return null;
  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          İşlem Geçmişi
        </Typography>
        <Box sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tarih</TableCell>
                <TableCell>Kullanıcı</TableCell>
                <TableCell>İşlem</TableCell>
                <TableCell>Açıklama</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((entry, index) => (
                <TableRow key={entry.processId ?? index}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{entry.date ?? '—'}</TableCell>
                  <TableCell>{entry.username ?? '—'}</TableCell>
                  <TableCell>{entry.processHistoryType ?? '—'}</TableCell>
                  <TableCell sx={{ whiteSpace: 'pre-wrap' }}>{entry.explanation ?? '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  );
}
